import { ManagePeopleApptsVaccineHistoryPage } from './manage-people-appts-vaccine-history.page';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    component: ManagePeopleApptsVaccineHistoryPage,
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ManagePeopleApptsVaccineHistoryPageRoutingModule {}
